import React from "react";
import { graphql, navigate, PageProps, useStaticQuery } from "gatsby";

import useWindowDimensions from "../../../../hooks/useWindowDimensions";

import ICONS from "../../../../constants/icons";
import MENU_PATHS from "../../../../constants/menu";
import { COLORS } from "../../../../utils/colors";

import Icon from "../../../icon/Icon";
import { INews, INewsData } from "../../../../interfaces/news";
import { GatsbyImage } from "gatsby-plugin-image";
import Tag from "../../../tag";

const LastNews = () => {
  const { isSmallScreen } = useWindowDimensions();

  const query = graphql`
    query {
      allPrismicNews(sort: { data: { date: DESC } }, limit: 1) {
        nodes {
          uid
          tags
          data {
            title {
              text
            }
            listing_image {
              alt
              copyright
              url
              gatsbyImageData
            }
            cover_image {
              alt
              copyright
              url
              gatsbyImageData
            }
            short_description {
              text
            }
            date(formatString: "MMMM D, YYYY")
          }
        }
      }
    }
  `;

  const data = useStaticQuery(query);
  const { allPrismicNews } = data || {};
  const { nodes } = allPrismicNews || [];
  const {
    uid,
    data: newsData,
    tags,
  } = nodes?.length > 0 ? nodes[0] : ({} as INews);

  const { title, short_description, cover_image, date, listing_image } =
    newsData || ({} as INewsData);

  const handleReadMore = () => {
    navigate(`${MENU_PATHS.NEWS}/${uid}/`);
  };
  const image = listing_image?.gatsbyImageData ? listing_image : cover_image;
  return (
    <div className="_wr fullHeight aligned-center -pt80">
      <div
        className={`_w m-header__lastNews text-white -pt25 -pb35 ${
          isSmallScreen ? "-gap15" : ""
        }`}
      >
        <div className="_12">
          <p className="-title sectionTitle text-white -mb20">News</p>
        </div>
        <div className="_12 _l6">
          {image && (
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.alt || ""}
            />
          )}
        </div>

        <div className="m-header__lastNews__infoSection column -row-gap20 _12 ofs_l1 _l5 justify-center">
          <div
            className={`aligned-center -gap10 flex-wrap ${
              isSmallScreen ? "align-self-center" : ""
            }`}
          >
            {tags && <Tag tags={tags} className="text-darkWhite" />}
            <span className="-title text-darkWhite">{date}</span>
          </div>

          <p className="m-header__lastNews__title -title sectionTitle text-white">
            {title?.text || ""}
          </p>
          <p className="m-header__lastNews__description text-darkWhite">
            {short_description?.text || ""}
          </p>

          <div
            onClick={handleReadMore}
            className={`pointer row -column-gap4 readMoreBtn ${
              isSmallScreen ? "align-self-center" : ""
            }`}
          >
            <p className="-readMore text-white">Read more</p>
            <Icon name={ICONS.SECOND_RIGHT_ARROW} color={COLORS.white} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastNews;
